/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseColorsResponse } from '../../models/base-colors-response';

export interface ListBaseColors$Params {
}

export function listBaseColors(http: HttpClient, rootUrl: string, params?: ListBaseColors$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseColorsResponse>> {
  const rb = new RequestBuilder(rootUrl, listBaseColors.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseColorsResponse>;
    })
  );
}

listBaseColors.PATH = '/api/scheduler/bases/colors';
